import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/landingContent";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-146" data-mp="ut5avbe00ts9">
      <SectionHeading eyebrow="Frequently asked questions" title="Everything you need to know" data-id="element-147" data-mp="729paw04yutg" />
      <div className="mx-auto mt-10 max-w-3xl divide-y divide-plum/10 border-y border-plum/10" data-id="element-148" data-mp="236s1xqedsw1">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-149" data-mp="c01nu8vadf6m" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-150" data-mp="byqbvlrot14f">
                <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-151" data-mp="hu8vszbgwoir">{f.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-rose transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-152" data-mp="msk7lflbp93m" />
              </button>
              <AnimatePresence initial={false} data-id="element-153" data-mp="vs7bq95fst0d">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-154" data-mp="3v9f1w6o21l63">
                    <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-155" data-mp="cwqxs3yzntpj">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
      <CtaButton className="mt-10" label="I'm ready — give me access" data-id="element-156" data-mp="np97gygfok4d" />
    </section>;
}